<template>
  <button
    class="global-btn-grey mt-3"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script setup>
defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped>
.global-btn-grey {
  background-color: #E9EEF5;
  color: black;
  padding: 0.5rem 1.25rem; /* = py-2 px-5 */
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  width: 97%;

}

.global-btn-grey:hover {
  background-color: #c5c5c5; /* สี hover เข้มขึ้นนิดหน่อย */
}

.global-btn-grey:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
